/** Normalize footer category link row (admin + public). */

export function getFooterItemTrekSlugs(item) {
  if (!item || typeof item !== 'object') return [];
  if (Array.isArray(item.trekSlugs) && item.trekSlugs.length) {
    return item.trekSlugs.map((s) => String(s).trim()).filter(Boolean);
  }
  const legacy = String(item.slug || '').trim();
  return legacy ? [legacy] : [];
}

export function getFooterItemTrekIds(item) {
  if (!item || typeof item !== 'object') return [];
  if (Array.isArray(item.trekIds) && item.trekIds.length) {
    return item.trekIds.map((id) => String(id).trim()).filter(Boolean);
  }
  const legacy = item.trekId != null && String(item.trekId).trim() !== '' ? String(item.trekId) : '';
  return legacy ? [legacy] : [];
}

export function normalizeFooterCategoryItem(item) {
  const label = String(item?.label || '').trim();
  const search = String(item?.search ?? '').trim();
  const trekSlugs = getFooterItemTrekSlugs(item);
  const trekIds = getFooterItemTrekIds(item);
  const out = {
    label,
    search: search || (trekSlugs.length ? '' : label)
  };
  if (trekIds.length) out.trekIds = trekIds;
  if (trekSlugs.length) out.trekSlugs = trekSlugs;
  return out;
}

export function footerCategoryItemHasTreks(item) {
  return getFooterItemTrekSlugs(item).length > 0;
}
